import { Button, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Modal } from 'components/atoms';
import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import styles from './styles.module.css';

const InvoiceInfoDeleteModal = memo((props) => {
  const { onClose, onClickOk, visible, className, restProps } = props;

  const { t: translatePopupAction } = useTranslation('popup-action');

  return (
    <Modal className={className} open={visible} {...restProps} onClose={onClose}>
      <div className={styles.confirm_modal_wrap}>
        <div>
          <div className={styles.warning_icon}>
            <Typography className={styles.text_icon}>!</Typography>
          </div>
          <Typography className={styles.modal_title}>
            {translatePopupAction('popup-remove-invoice-info.confirmation')}
          </Typography>
          <Typography className={styles.modal_content}>
            {translatePopupAction('popup-remove-invoice-info.content')}
          </Typography>
        </div>
        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <Button className={clsx(styles.btn, styles.brown_btn)} onClick={onClose}>
            {translatePopupAction('popup-remove-invoice-info.no')}
          </Button>
          <Button onClick={onClickOk} className={clsx(styles.btn, styles.fill_btn)}>
            {translatePopupAction('popup-remove-invoice-info.yes')}
          </Button>
        </div>
      </div>
    </Modal>
  );
});

export default InvoiceInfoDeleteModal;
